import { HTMLProps, RefAttributes } from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { cn } from "@/utils/helpers";
import Markdown from "@/components/common/Markdown";
import Overlay from "@/components/common/Overlay";
import styles from "../Tooltip.module.css";

export interface TooltipOverlayProps extends HTMLProps<HTMLDivElement> {
	footer?: string | null;
	persist?: boolean;
	ContentProps?: RadixTooltip.TooltipContentProps & RefAttributes<HTMLDivElement>;
};

export default function TooltipOverlay({
	footer,
	persist,
	className,
	children,
	...props
} : TooltipOverlayProps) {
	
	return(
		<Overlay
			role="tooltip"
			className={cn(
				styles.TooltipOverlay,
				persist ? styles.TooltipOverlay_persist : null,
				className
			)}
			{...props}
		>
			{children ?
				<div
					className={styles.TooltipInner}
				>
					{typeof children === "string" ?
						<Markdown>
							{children}
						</Markdown>
					: children}
				</div>
			: null}
			{footer ?
				<Markdown
					className={styles.TooltipFooter}
				>
					{footer}
				</Markdown>
			: null}
		</Overlay>
	)
}